import { render, staticRenderFns } from "./MdCard.vue?vue&type=template&id=18bd95d0&scoped=true"
import script from "./MdCard.vue?vue&type=script&lang=js"
export * from "./MdCard.vue?vue&type=script&lang=js"
import style0 from "./MdCard.vue?vue&type=style&index=0&id=18bd95d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd95d0",
  null
  
)

export default component.exports